var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useAccount } from '../../../../hooks';
import { useBridgeService } from './useBridgeService';
export function useTokenBalance(asset, chain) {
    const bridgeService = useBridgeService();
    const { account } = useAccount();
    return useQuery({
        queryKey: ['tokenBalance', chain, asset, account],
        queryFn: () => __awaiter(this, void 0, void 0, function* () { return yield bridgeService.getBalance(chain, asset, account); }),
        enabled: Boolean(bridgeService && account && chain && asset),
    });
}
